var _mask, _path, _path2, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPindown(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 40,
    viewBox: "0 0 33 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "path-1-inside-1",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.8546 7.46209C5.61099 9.07884 0.999998 14.7509 0.999999 21.5C0.999999 29.5081 7.49187 36 15.5 36C23.5081 36 30 29.5081 30 21.5C30 14.7509 25.389 9.07884 19.1454 7.46209L15.5 1.26763e-06L11.8546 7.46209Z"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.8546 7.46209C5.61099 9.07884 0.999998 14.7509 0.999999 21.5C0.999999 29.5081 7.49187 36 15.5 36C23.5081 36 30 29.5081 30 21.5C30 14.7509 25.389 9.07884 19.1454 7.46209L15.5 1.26763e-06L11.8546 7.46209Z",
    fill: "#011133"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.8546 7.46209L11.9172 7.70411L12.0287 7.67525L12.0792 7.57183L11.8546 7.46209ZM19.1454 7.46209L18.9208 7.57183L18.9713 7.67525L19.0828 7.70411L19.1454 7.46209ZM15.5 1.26763e-06L15.7246 -0.109736L15.5 -0.569541L15.2754 -0.109736L15.5 1.26763e-06ZM1.25 21.5C1.25 14.8677 5.78125 9.293 11.9172 7.70411L11.7919 7.22007C5.44073 8.86468 0.749998 14.6342 0.749999 21.5L1.25 21.5ZM15.5 35.75C7.62994 35.75 1.25 29.3701 1.25 21.5L0.749999 21.5C0.749999 29.6462 7.3538 36.25 15.5 36.25L15.5 35.75ZM29.75 21.5C29.75 29.3701 23.3701 35.75 15.5 35.75L15.5 36.25C23.6462 36.25 30.25 29.6462 30.25 21.5L29.75 21.5ZM19.0828 7.70411C25.2187 9.293 29.75 14.8676 29.75 21.5L30.25 21.5C30.25 14.6342 25.5593 8.86468 19.2081 7.22007L19.0828 7.70411ZM15.2754 0.109739L18.9208 7.57183L19.3701 7.35235L15.7246 -0.109736L15.2754 0.109739ZM12.0792 7.57183L15.7246 0.109739L15.2754 -0.109736L11.6299 7.35235L12.0792 7.57183Z",
    fill: "white",
    mask: "url(#path-1-inside-1)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 15.6382,
    cy: 21.6382,
    r: 11.8618,
    transform: "rotate(180 15.6382 21.6382)",
    stroke: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d",
    x: 0.276367,
    y: 7.27637,
    width: 32.7235,
    height: 32.7235,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 1,
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPindown);
export default __webpack_public_path__ + "static/media/pindown.f252a445b22a16a9729fe1f9f2f45824.svg";
export { ForwardRef as ReactComponent };